/*
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.35
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';
import {ChecklistQualitativeAnswerTypeDTO} from './ChecklistQualitativeAnswerTypeDTO';
import {OperationalScopeDTO} from './OperationalScopeDTO';

/**
 * The ChecklistQualitativeQuestionOperationalScopeDTO model module.
 * @module model/ChecklistQualitativeQuestionOperationalScopeDTO
 * @version v0
 */
export class ChecklistQualitativeQuestionOperationalScopeDTO {
  /**
   * Constructs a new <code>ChecklistQualitativeQuestionOperationalScopeDTO</code>.
   * @alias module:model/ChecklistQualitativeQuestionOperationalScopeDTO
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>ChecklistQualitativeQuestionOperationalScopeDTO</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/ChecklistQualitativeQuestionOperationalScopeDTO} obj Optional instance to populate.
   * @return {module:model/ChecklistQualitativeQuestionOperationalScopeDTO} The populated <code>ChecklistQualitativeQuestionOperationalScopeDTO</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new ChecklistQualitativeQuestionOperationalScopeDTO();
      if (data.hasOwnProperty('operationalScope'))
        obj.operationalScope = OperationalScopeDTO.constructFromObject(data['operationalScope']);
      if (data.hasOwnProperty('enabled'))
        obj.enabled = ApiClient.convertToType(data['enabled'], 'Boolean');
      if (data.hasOwnProperty('checklistQualitativeAnswerType'))
        obj.checklistQualitativeAnswerType = ChecklistQualitativeAnswerTypeDTO.constructFromObject(data['checklistQualitativeAnswerType']);
    }
    return obj;
  }
}

/**
 * @member {module:model/OperationalScopeDTO} operationalScope
 */
ChecklistQualitativeQuestionOperationalScopeDTO.prototype.operationalScope = undefined;

/**
 * @member {Boolean} enabled
 */
ChecklistQualitativeQuestionOperationalScopeDTO.prototype.enabled = undefined;

/**
 * @member {module:model/ChecklistQualitativeAnswerTypeDTO} checklistQualitativeAnswerType
 */
ChecklistQualitativeQuestionOperationalScopeDTO.prototype.checklistQualitativeAnswerType = undefined;

